import React from "react";

// This is 404 page for gatsby based on the convention that the file is called 404

export default (): JSX.Element => {
	return <div>404 :(</div>;
};
